// platform side-nav (green rail) only — kept out of the shared NavigationContainer constants so the
// no-code navigation variants carry no platform-specific styling.

// platform rail only — interface/no-code expandable navs (and the shared overlay constants) stay 280
export const EXPANDED_PLATFORM_SIDE_NAV_WIDTH = '!w-[292px]';

export const UA_PLATFORM_SIDE_NAV = 'ua-platform-side-nav';

// When primary nav container overlaps with secondary nav container,
// we need to add this styles to the secondary nav container
export const UA_PLATFORM_SIDE_NAV_OVERLAPPING_STYLES = {
  boxShadow: '0 -2px 8.5px 0 rgba(157, 150, 135, 0.10)',
  borderTop: '2px solid var(--border-tertiary)',
};

export const UA_PLATFORM_SIDE_NAV_CUSTOM_SCROLLBAR = 'ua-platform-side-nav-custom-scrollbar';
